<script>
export default {
  name: "CsSpace",
  props: {
    /**
     * 对齐方式
     * @values 'start', 'end', 'center', 'baseline'
     */
    align: {
      type: String,
    },
    /**
     * 间距方向
     * @values 'vertical' , 'horizontal'
     */
    direction: {
      type: String,
      default: "horizontal",
    },
    /**
     * 间距大小，支持分别制定横向和竖向的间距
     * @values number | 'mini' | 'small' | 'medium' | 'large' | [SpaceSize, SpaceSize]
     */
    size: {
      type: [Number, String, Array],
      default: "small",
    },
    /**
     * 环绕类型的间距，用于折行的场景。
     */
    wrap: {
      type: Boolean,
    },
    /**
     * 充满整行
     */
    fill: {
      type: Boolean,
    },
    /**
     * 是否展示分隔符
     */
    split: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    cls() {
      const mergedAlign =
        this.align ?? (this.direction === "horizontal" ? "center" : "");
      return [
        "cs-space",
        {
          [`cs-space-${this.direction}`]: this.direction,
          [`cs-space-align-${mergedAlign}`]: mergedAlign,
          [`cs-space-wrap`]: this.wrap,
          [`cs-space-fill`]: this.fill,
        },
      ];
    },
  },
  render() {
    function getMargin(size) {
      if (Object.prototype.toString.call(size) === "[object Number]") {
        return size;
      }
      switch (size) {
        case "mini":
          return 4;
        case "small":
          return 8;
        case "medium":
          return 16;
        case "large":
          return 24;
        default:
          return 8;
      }
    }

    const getMarginStyle = (isLast) => {
      const style = {};

      const marginRight = `${getMargin(
        Array.isArray(this.size) ? this.size[0] : this.size
      )}px`;
      const marginBottom = `${getMargin(
        Array.isArray(this.size) ? this.size[1] : this.size
      )}px`;

      if (isLast) {
        return this.wrap ? { marginBottom } : {};
      }

      if (this.direction === "horizontal") {
        style.marginRight = marginRight;
      }
      if (this.direction === "vertical" || this.wrap) {
        style.marginBottom = marginBottom;
      }

      return style;
    };
    const children = (this.$slots.default ? this.$slots.default : []).filter(
      (el) => !el.isComment && !!el.tag
    );
    return (
      <div class={this.cls}>
        {children.map((child, index) => {
          const shouldRenderSplit =
            (this.$slots.split || this.split) && index > 0;
          return [
            shouldRenderSplit && (
              <div class={`cs-space-item-split`} style={getMarginStyle(false)}>
                {this.$slots.split || <div class="cs-space-divider"></div>}
              </div>
            ),
            <div
              class={`cs-space-item`}
              style={getMarginStyle(index === children.length - 1)}
            >
              {child}
            </div>,
          ];
        })}
      </div>
    );
  },
};
</script>

<style lang="scss" scoped>
.cs-space {
  display: inline-flex;

  &-horizontal {
    .cs-space-item {
      display: flex;
      align-items: center;
    }
  }

  &-vertical {
    flex-direction: column;
  }

  &-align-baseline {
    align-items: baseline;
  }

  &-align-start {
    align-items: flex-start;
  }

  &-align-end {
    align-items: flex-end;
  }

  &-align-center {
    align-items: center;
  }

  &-wrap {
    flex-wrap: wrap;
  }

  &-fill {
    display: flex;
  }

  &-divider {
    display: inline-block;
    width: 1px;
    height: 1em;
    vertical-align: middle;
    position: relative;
    background-color: #d0d2d7;
  }
}
</style>
